import { PUBLIC_URL } from 'config';
import { router } from 'routers/routers.instance';

export const jumioRedirectToErrorPage = () =>
  window.location.replace(PUBLIC_URL + '/oops');

export const jumioEndFlowRedirect = (jumioCaller: string) => {
  const target = jumioCaller === '/profile' ? jumioCaller : '';

  setTimeout(() => {
    router.navigate({
      to: target + '/?info=uploaded#info-document',
      replace: true,
    });
  }, 3000);
};
